// src/geoman-shim.ts
import L from "leaflet"; // hits our alias -> leaflet-global.ts
const windowWithLeaflet = window as unknown as { L?: typeof L };
if (!windowWithLeaflet.L) windowWithLeaflet.L = L;

// Register plugin for side effects
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

